// extracted by mini-css-extract-plugin
module.exports = {"infoBox":"info-box-module--infoBox--3zYo3","iconContainer":"info-box-module--iconContainer--25aA7","linkContainer":"info-box-module--linkContainer--3xQP9"};